import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { CondicionPagoSelect } from 'sharedComponents/select'

const CondicionDePagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='condicionPago'>
          {({ field }) => <CondicionPagoSelect {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-CondicionDePago' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CondicionDePagoFormGroup)
